module.exports = __webpack_public_path__ + "img/epTerm.db5d1624.png";